export const LOCAL_STORAGE_LANGUAGE = 'language';
